import { CONST } from "../CONST";

export default class HomeButton extends Phaser.GameObjects.Container{
    private opened = false;
    private pointerOverButton = false;

    private mainButton : Phaser.GameObjects.Image;

    private innerContainer : Phaser.GameObjects.Container;

    private onExit !: () => void;

    constructor(scene: Phaser.Scene, x: number,  y: number) {
        super(scene, x, y);

       this.mainButton = this.createMainButton();
       this.innerContainer = this.createInnerContainer();
       this.updateDisplay();

        this.add([this.innerContainer, this.mainButton]);

        scene.add.existing(this);

        this.setScale(0.75);
        this.setScrollFactor(0);
    }

    createMainButton(){
        let button = this.scene.add.image(0, 0, CONST.HOME_BUTTON.NORMAL)
                    .setInteractive({useHandCursor: true, pixelPerfect: true, alphaTolerance: 1})
                    .setScrollFactor(0);

        button.on("pointerup", () => {
            this.handleMainButtonClick();
        });    
        
        button.on("pointerover", () => {
            this.pointerOverButton = true;
            this.updateDisplay();
        });

        button.on("pointerout", () => {
            this.pointerOverButton = false;
            this.updateDisplay();
        });

        return button;
    }

    handleMainButtonClick(){
        this.opened = !this.opened;
        this.updateDisplay();
    }

    createInnerContainer(){
        let bg = this.scene.add.image(0, 0, CONST.HOME_BUTTON.BACKGROUND).setScrollFactor(0);

        let check_button = this.scene.add.image(-14.2, -4.4, CONST.HOME_BUTTON.CHECK).setScrollFactor(0);
        let check_highlight = this.createInnerButton(-11, -4.4, CONST.HOME_BUTTON.CHECK_HIGHLIGHT, () => {this.loadMenuScene()}).setScrollFactor(0);
 
        let x_button = this.scene.add.image(51, -3.7, CONST.HOME_BUTTON.X).setScrollFactor(0);
        let x_highlight = this.createInnerButton(51, -3.7, CONST.HOME_BUTTON.X_HIGHLIGHT, () => {this.handleMainButtonClick()}).setScrollFactor(0);
        
 
        let innerContainer = this.scene.add.container(92, 0).setScrollFactor(0);
        innerContainer.add([bg, check_button, check_highlight, x_button, x_highlight,]);

        return innerContainer;
    }

    createInnerButton(x: number, y: number, texture: string, onClick: () => void){
        let button = this.scene.add.image(x, y, texture)
            .setAlpha(0.01)
            .setInteractive({useHandCursor: true, pixelPerfect: true, alphaTolerance: 0});

        button.on("pointerup", () => {
            onClick();
        });    

        button.on("pointerover", () => {
            button.alpha = 1;
        });

        button.on("pointerout", () => {
            button.alpha = 0.01; //hack to keep interactivity on "invisible" image. Should be 0 though.
        });

        return button;
            }

    updateDisplay(){
        this.mainButton.setTexture(this.opened || this.pointerOverButton ? CONST.HOME_BUTTON.HIGHLIGHT : CONST.HOME_BUTTON.NORMAL);
        this.innerContainer.setVisible(this.opened);
    }

    public addExitEvent(onExit: () => void){
        this.onExit = onExit;
    }

    loadMenuScene(){
        if (this.onExit){
            this.onExit();
        }

        this.scene.scene.start(CONST.SCENES.MENU);
    }
}